import { render, staticRenderFns } from "./CompSchoolAdminStats.vue?vue&type=template&id=980215fa"
import script from "./CompSchoolAdminStats.vue?vue&type=script&lang=js"
export * from "./CompSchoolAdminStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports